export const OTHER_SLOT_LABEL: string = 'Other:';

export const WORK_DAYS: string[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
];

export const PANATCH_WORK_DAYS: string[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
];

export const TIME_SLOTS: string[] = ['Morning', 'Afternoon', OTHER_SLOT_LABEL];

export const PANATCH_TIME_SLOTS: string[] = [
  'Morning',
  'Afternoon',
  OTHER_SLOT_LABEL,
];

export const ALBASTAR_TIME_SLOTS: string[] = [
  '7:30 - 11:30',
  '11:30 - 3:30',
  'All day',
  OTHER_SLOT_LABEL,
];

export const WALKTHROUGH_TIME_SLOTS: string[] = [
  'Mornings ( 8 AM - 11 AM )',
  'Afternoons ( 1 PM - 5 PM )',
  'Evenings ( 5 PM - 8 PM )',
];

export const WALKTHROUGH_PANATCH_TIME_SLOTS: string[] = [
  'Mornings ( 7 AM - 11 AM )',
  'Afternoons ( 1 PM - 5 PM )',
  'Evenings ( 5 PM - 8 PM )',
];

export const WALKTHROUGH_ALBASTAR_TIME_SLOTS: string[] = [
  '7:30 - 11:30',
  '11:30 - 3:30',
  'All day',
];

export const timeSlotsForTheme = (theme: string | null): string[] => {
  if (theme === 'Albaster') {
    return ALBASTAR_TIME_SLOTS;
  }

  if (theme === 'Panatch') {
    return PANATCH_TIME_SLOTS;
  }

  return TIME_SLOTS;
};

export const workDaysForTheme = (theme: string | null): string[] => {
  if (theme === 'Panatch') {
    return PANATCH_WORK_DAYS;
  }

  return WORK_DAYS;
};